module.exports = __webpack_public_path__ + "img/3.518f5392.jpg";